import usePutRequestUpgrade from '../utils/usePutRequestUpgrade';
import { CreatedInterfaces } from '../../interfaces';

const resource = 'card-emboss-affinity-group-update'
const useUpdateEmbossCardAffinityGroup = (cardAffinityGroupId: string) => {

  const { putData, putError, putLoading, executePut } = usePutRequestUpgrade<CreatedInterfaces<typeof resource>>({
    path: `v1/card_affinity_groups/${cardAffinityGroupId}/emboss`
  });

  return {
    putData,
    putError,
    putLoading,
    executePut
  }
}

export default useUpdateEmbossCardAffinityGroup;